/**
 * Validation helpers and rules
 * Used for for configuration from consumer
 */

import { applications } from '../constants';
import messages from '../constants/logMessages.json';
import { AnalyticsWrapperProps } from '../types/configs';
import { jsonToString } from '../utils/analyticsUtils';
import logging, { getMessage } from '../utils/logging';

const { errorHeading, errorBold } = messages;
// validation helpers
const isValidAppName = (appName = '') =>
  applications[appName.replace(/[^\w\s]/g, '').toUpperCase()];

interface ValidationRuleItem {
  validation: Function;
  type: string;
  required: boolean;
  inValidMessage: string;
}
interface ValidationRuleItems extends Array<ValidationRuleItem> {}

export const validationRules: ValidationRuleItems = [
  {
    validation: isValidAppName,
    type: 'appName',
    required: false,
    inValidMessage:
      'QAL Error: `appName` is not valid, and it is not in our whitelist. You will engage with the QBE Digital Analytics Team. For the meanwhile, please set to `appName=DEVELOPMENT`',
  },
];

/**
 * runConfigValidation
 *
 * Helper for running validation rules and throw errors when rules are meet
 *
 * @param {Object} config
 * @param {Array} rules
 */
export const runConfigValidation = (consumerConfig: AnalyticsWrapperProps) => {
  try {
    validationRules.forEach((rule) => {
      const { type, required, validation, inValidMessage } = rule;
      if (required) {
        if (consumerConfig[type] && !validation(consumerConfig[type])) {
          throw new Error(inValidMessage);
        }
      }
      return true;
    });
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'runConfigValidation',
        jsonToString([e as object]),
      ]),
      errorHeading,
      errorBold
    );
  }
};
